<template>
	<div class="wutuNew2 wutuUL">
		<ul class="w69">
			<li v-for="(item,index) in dataList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
		    <router-link  :to="item.Url" :href="item.Url" class="flexDiv">
		      <div class="tuBox_img">
				  <img :src="item.Cover" alt="">
			  </div>
			  <div class="textBox">
                    <div class="dtxwNew_text flexDiv">
                        <h3 class="title txt-cut1">{{ item.Title }}</h3>
                        <span>{{ setTimeformat(item.ShowTime6, "yyyy-mm-dd") }}</span>
                    </div>
                    <p class="txt-cut3">{{ item.Describe }}</p>
			  </div>
		    </router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'noImgList2',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
.wutuNew2{
	width: 6.9rem;
	ul{
		li{
			width: 100%;
			height: 1.9rem;
			padding: 0.1rem;
			box-sizing: border-box;
			background-color: #ffffff;
			box-shadow: 0rem 0rem 0.16rem 0rem 
			rgba(107, 107, 107, 0.13);
			margin-bottom: 0.25rem;
			&:last-child{
				margin-bottom: 0rem;
			}
			a{
				.tuBox_img{
					width: 2.85rem;
					height: 1.7rem;
					background-color: #a9a9a9;
					margin: 0;
				}
				.textBox{
					width: 3.55rem;
					padding-top: 0.1rem;
					.dtxwNew_text{
						margin-bottom: 0.15rem;
						h3{
							width: 1.9rem;
							font-size: 0.26rem;
							font-weight: normal;
							font-stretch: normal;
							line-height: 0.3rem;
							letter-spacing: 0.01rem;
							color: #333333;
						}
						span{
							font-size: 0.22rem;
							font-weight: normal;
							font-stretch: normal;
							line-height: 0.3rem;
							letter-spacing: 0.01rem;
							color: #999999;
						}
					}
					p{
						font-size: 0.24rem;
						font-weight: normal;
						font-stretch: normal;
						line-height: 0.36rem;
						letter-spacing: 0.02rem;
						color: #666666;
					}
				}	
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/noImgList2.vue